import React from "react";
import SortableDataTable from "components/common/SortableDataTable";
import * as ProviderApi from "api/ProviderApi";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import toast from "utils/toast";
import {downloadFile} from "utils/request";
import * as UserPermissions from "constants/UserPermissions";
import { PermissionTypes, userHasPermission } from "utils/permissions/rolesPermissions";


function ProviderPayoutReportTable(props) {

  const handleDownloadExcel = async () => {
    if (props.isAdminReport && props.canViewAdminPayoutReport) {
        toast.success("Generating Export...");
        const res = await ProviderApi.exportAdminCheckSummary (props.downloadParameters);
        downloadFile(res, "xlsx");
    }

    if (props.canViewProviderPayoutReport) {
      toast.success("Generating Export...");
      if(props.isNHO) {
        const res = await ProviderApi.exportNHOProviderCheckSummary(props.downloadParameters);
        downloadFile(res, "xlsx");
      } else {
        const res = await ProviderApi.exportProviderCheckSummary(props.downloadParameters);
        downloadFile(res, "xlsx");
      }
    }
  };

  const FIRST_COLUMN = [
    {
      name: "Manufacturer Name",
      selector: "manufacturerName",
      key: "manufacturerName",
    },
  ]
  
  const EXTRA_COLUMN = props.isAdminReport ? [    
    {
      name: "Clinic Id",
      selector: "clinicId",
      key: "clinicId",
      sortable: true,
    }] : [];
  
  
  const REMAINING_COLUMN_NAMES = [    
    {
      name: "Corp Id",
      selector: "corporateGroupId",
      key: "corporateGroupId",
      sortable: true,
    },
    {
      name: "MFR Number",
      selector: "manufacturerClinicCode",
      key: "manufacturerClinicCode",
    },
    {
      name: "Clinic Name",
      selector: "clinicName",
      key: "ClinicName",
      sortable: true,
    },
    {
      name: "Redemptions",
      selector: "totalNumberOfRedemptions",
      key: "totalNumberOfRedemptions",
      total: true,
      totalClasses: "text-center",
      sortable: true,
      format: row => (<div className="text-center">{row.totalNumberOfRedemptions}</div>)
    },
    {
      name: "Rebate Totals",
      selector: "totalRebateAmount",
      key: "totalRebateAmount",
      type: "currency",
      total: true,
      totalClasses: "text-center",
      sortable: true,
      format: row => (<div className="text-center">${row.totalRebateAmount}</div>)
    },
    {
      name: "Redemption Range",
      selector: "redemptionRange",
      key: "redemptionRange",
    },
    {
      name: "Check Number",
      selector: "checkNumber",
      key: "checkNumber",
    },
  ];

  const COLUMN_NAMES = props.isAdminReport ? FIRST_COLUMN.concat(EXTRA_COLUMN).concat(REMAINING_COLUMN_NAMES) : FIRST_COLUMN.concat(REMAINING_COLUMN_NAMES);

  return (
      <SortableDataTable
        striped
        green
        hideSearchBar={false}
        title={props.title}
        downloadExcel={props.canViewProviderPayoutReport || props.canViewAdminPayoutReport ? handleDownloadExcel : undefined}
        columns={COLUMN_NAMES}
        rawData={props.checkData}
        onClick={props.onRowClick}
        showTotals={props.checkData?.length > 1}
      />
  );
}

ProviderPayoutReportTable.propTypes = {
  canViewProviderPayoutReport: PropTypes.bool,
  canViewAdminPayoutReport: PropTypes.bool,
  downloadParameters: PropTypes.object,
  title: PropTypes.string,
  checkData: PropTypes.array,
  onClick: PropTypes.func,
  showTotals: PropTypes.bool,
  isNHO: PropTypes.bool,
  isAdminReport: PropTypes.bool,
};

export default connect(
  (state) => {
    const userProfile = state.user.userProfile;
    const canViewProviderPayoutReport = userHasPermission(PermissionTypes.VIEW, UserPermissions.PROVIDER_PAYOUT_REPORT, userProfile);
    const canViewAdminPayoutReport = userHasPermission(PermissionTypes.VIEW, UserPermissions.ADMIN_PROVIDER_PAYOUT_REPORT, userProfile);    
    return {
      canViewProviderPayoutReport,
      canViewAdminPayoutReport
    };
  },
)(ProviderPayoutReportTable);